import Vue from 'vue'
import ElementUI from 'element-ui'
import './styles/element-theme.scss'
import './styles/global.scss'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
